import { OccupationValues } from './types';

export const OCCUPATION_VALUES: OccupationValues = {
  userOccupationTitle: null,
  _rowTimestamp: null,
};
